/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from 'react';
import routes from "../../../../../Routes/routes";
import HeadTittle from "../../../../../components/HeadTittle";
import CreateContractApp from "../../Functionality/ContractCreateUpdateFlows/CreateContractApp";
import DivContainerBody from "../../../../../components/DivContainerBody";
import ButtonIcon from "../../../../../components/buttons/ButtonIcon";
import {AddIcon, CleanIcon} from "../../../../../components/buttons/IconButtons";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import CommonContractApp from "../../Functionality/ContractCreateUpdateFlows/CommonContractApp";
import ContractFields from "../../SubComponents/ContractCreateUpdateFlows/ContractFields";
import {permissionObj} from "../../../../../Helpers/permission";

export const CreateContract = () => {
    const props  = CommonContractApp();
    const {
        t,
        navigate,
        DEV,
        permission,
        handleClearAll,
        contract,
        setContract,
        emptyFields,
        isValidStartDate,
        setIsValidStartDate,
        isValidEndDate,
        setIsValidEndDate,
        getAllContractor,
        handleStartDateChange,
        handleEndDateChange,
        handleOnBack
    } = props;

    const { handleSubmit} = CreateContractApp(props);

    if(!DEV && (!permission?.includes(permissionObj.WEB_CONTRACTOR_CONTRACT_READ) || !permission?.includes(permissionObj.WEB_CONTRACTOR_CONTRACT_CREATE))) navigate(routes.forbidden);

    return (
        <>
            <HeadTittle
                name={t('create')}
                onBack={handleOnBack}
                divStack={
                    <ButtonIcon
                        className='btn-clean-secondary-600'
                        id='btn_cc_clean_all_inputs'
                        Icon={CleanIcon}
                        title={'clear_instances'}
                        onClick={handleClearAll}
                        iconProps='btn-icon-svg-12px icon-color-general-00'
                    />
                }
            >
                <ButtonAction
                    id='btn_cc_create'
                    name={ 'create'}
                    Icon={ AddIcon}
                    className={'btn-icon-add'}
                    onClick={handleSubmit}
                />
            </HeadTittle>
            <DivContainerBody>
                <div className={"row mt-4"}>
                    <ContractFields
                        contract={contract}
                        setContract={setContract}
                        emptyFields={emptyFields}
                        isValidStartDate={isValidStartDate}
                        setIsValidStartDate={setIsValidStartDate}
                        isValidEndDate={isValidEndDate}
                        setIsValidEndDate={setIsValidEndDate}
                        getAllContractor={getAllContractor}
                        handleStartDateChange={handleStartDateChange}
                        handleEndDateChange={handleEndDateChange}
                    />
                </div>
            </DivContainerBody>
        </>
    );
};
